import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button as MuiButton } from '@material-ui/core';
import clsx from 'clsx';
var useStyles = makeStyles(function (theme) {
  var palette = theme.palette;
  return {
    Button: {
      alignItems: 'center',
      background: palette.secondary.main,
      border: "2px solid ".concat(palette.secondary.main),
      color: palette.tertiary.dark,
      cursor: 'pointer',
      display: 'flex',
      fontSize: '0.8rem',
      justifyContent: 'center',
      letterSpacing: '2.4px',
      lineHeight: '1rem',
      maxWidth: '290px',
      padding: '15px 8px',
      textAlign: 'center',
      textTransform: 'uppercase',
      transition: 'all 0.4s ease',
      width: '100%',
      '&:disabled': {
        backgroundColor: palette.grey[300],
        borderColor: palette.grey[300],
        cursor: 'not-allowed',
        transition: 'none',
        '&:hover': {
          backgroundColor: palette.grey[300],
          borderColor: palette.grey[300],
          color: palette.tertiary.dark
        }
      },
      '&:hover': {
        background: palette.tertiary.main,
        borderColor: palette.tertiary.main,
        color: palette.common.white
      },
      '&.primary': {
        background: palette.secondary.main,
        borderColor: palette.secondary.main,
        color: palette.tertiary.dark,
        '&:disabled': {
          '&:hover': {
            color: palette.tertiary.dark
          }
        },
        '&:hover': {
          background: palette.tertiary.main,
          borderColor: palette.tertiary.main,
          color: palette.common.white
        }
      },
      '&.secondary': {
        background: palette.common.white,
        borderColor: palette.secondary.main,
        color: palette.tertiary.dark,
        '&:disabled': {
          '&:hover': {
            color: palette.tertiary.dark
          }
        },
        '&:hover': {
          background: palette.tertiary.main,
          borderColor: palette.tertiary.main,
          color: palette.common.white
        }
      },
      '&.tertiary': {
        background: palette.old.green,
        borderColor: palette.old.green,
        color: palette.tertiary.dark,
        '&:disabled': {
          '&:hover': {
            color: palette.tertiary.dark
          }
        },
        '&:hover': {
          background: palette.primary.main,
          borderColor: palette.primary.main,
          color: palette.common.white
        }
      },
      '&.warning': {
        background: '#ec3a3a',
        borderColor: '#ec3a3a',
        color: palette.common.white,
        '&:disabled': {
          '&:hover': {
            color: palette.common.white
          }
        },
        '&:hover': {
          background: palette.primary.main,
          borderColor: palette.primary.main,
          color: palette.common.white
        }
      },
      '&.border': {
        background: 'transparent',
        borderColor: palette.secondary.main,
        color: palette.common.white,
        borderWidth: '4px',
        width: '180px',
        height: '40px',
        '&:disabled': {
          '&:hover': {
            color: palette.common.white
          }
        },
        '&:hover': {
          background: palette.secondary.main,
          borderColor: palette.secondary.main,
          color: palette.common.white
        }
      }
    }
  };
}, {
  name: 'button'
});

/**
 * Button Component
 *
 * Variant = 'primary' Primary = Mainly used type of button
 *
 * @param {Node} props.children :: context that lives inside the button component
 * @param {Boolean} props.fullWidth :: determines if the button should have a max-width of 290px (ex: 'primary', 'secondary', 'tertiary')
 * @param {Function} props.onClick :: function that executes when button is clicked
 * @param {String} props.variant = 'primary' :: determines how the button should display based on set variations
 */
export function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      onClick = _ref.onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      restOfAttributes = _objectWithoutProperties(_ref, ["children", "className", "fullWidth", "onClick", "variant"]);

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiButton, _extends({
    className: clsx(classes.Button, className, variant),
    fullWidth: fullWidth,
    onClick: onClick
  }, restOfAttributes), children);
}